export const NotificationTypes = {
    UPDATE_MESSAGE_COUNT: 'update-message-count',
    UPDATE_INTERVIEW_SHEET_COUNT: 'update-interview-sheet-count',
    HAS_NEW_MESSAGE: 'has-new-message',
    RESERVATION_ABOUT_TO_START: 'reservation-about-to-start',
    RESERVATION_INTERVIEW_SHEET: 'reservation-interview-sheet',
};
